import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Users, Shield } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { RoleListItem } from '@/lib/types/api'

interface RoleCardProps {
  role: RoleListItem
}

export function RoleCard({ role }: RoleCardProps) {
  const { t } = useTranslation()

  return (
    <Card className="hover:shadow-md transition-shadow h-full flex flex-col">
      <CardHeader className="pb-3 flex-1">
        <div className="flex items-start justify-between mb-2">
          <div className="flex items-center gap-2">
            <CardTitle className="text-xl">{role.name}</CardTitle>
            {role.isSystem && (
              <Badge variant="secondary" className="flex items-center gap-1">
                <Shield className="h-3 w-3" aria-hidden="true" />
                <span>{t('rbac.systemRole')}</span>
              </Badge>
            )}
          </div>
        </div>
        <CardDescription className="text-sm">{role.description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div className="flex items-center gap-2">
            <Shield className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
            <div>
              <p className="font-medium">{t('rbac.permissions')}</p>
              <p className="text-muted-foreground">{role.permissionCount}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Users className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
            <div>
              <p className="font-medium">{t('rbac.users')}</p>
              <p className="text-muted-foreground">{role.userCount}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
